"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.printWarning = void 0;
var localization_1 = require("./localization");
var defaultTranslation = 'en-us';
function printWarning(locale) {
    if (locale === void 0) { locale = defaultTranslation; }
    locale = locale ? locale.toLowerCase() : locale;
    var content = localization_1.default[locale] ? localization_1.default[locale] : localization_1.default[defaultTranslation];
    console.log('%c' + content.warning, 'font-size: 30px; color: #F61F1F; background-color: #FFFF00;');
    console.log('%c' + content.message, 'font-size: 16px; color: #464656; background-color: #FFF;');
}
exports.printWarning = printWarning;
//# sourceMappingURL=index.js.map